var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartcopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3582 19.2C19.9947 19.2 20.6052 19.4529 21.0553 19.9029C21.5053 20.353 21.7582 20.9635 21.7582 21.6C21.7582 22.2365 21.5053 22.847 21.0553 23.2971C20.6052 23.7471 19.9947 24 19.3582 24C18.0262 24 16.9582 22.92 16.9582 21.6C16.9582 20.268 18.0262 19.2 19.3582 19.2ZM0.158203 0H4.0822L5.2102 2.4H22.9582C23.2765 2.4 23.5817 2.52643 23.8067 2.75147C24.0318 2.97652 24.1582 3.28174 24.1582 3.6C24.1582 3.804 24.0982 4.008 24.0142 4.2L19.7182 11.964C19.3102 12.696 18.5182 13.2 17.6182 13.2H8.6782L7.5982 15.156L7.5622 15.3C7.5622 15.3796 7.59381 15.4559 7.65007 15.5121C7.70633 15.5684 7.78264 15.6 7.8622 15.6H21.7582V18H7.3582C6.0262 18 4.9582 16.92 4.9582 15.6C4.9582 15.18 5.0662 14.784 5.2462 14.448L6.8782 11.508L2.5582 2.4H0.158203V0ZM7.3582 19.2C7.99472 19.2 8.60517 19.4529 9.05526 19.9029C9.50535 20.353 9.7582 20.9635 9.7582 21.6C9.7582 22.2365 9.50535 22.847 9.05526 23.2971C8.60517 23.7471 7.99472 24 7.3582 24C6.0262 24 4.9582 22.92 4.9582 21.6C4.9582 20.268 6.0262 19.2 7.3582 19.2ZM18.1582 10.8L21.4942 4.8H6.3262L9.1582 10.8H18.1582Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartcopy);
export default __webpack_public_path__ + "static/media/cartcopy.982c5bfb7597f1ebe6e54d58d602f900.svg";
export { ForwardRef as ReactComponent };